import {getUser} from "../../../utils/getUser";
import APIClient from "../../../utils/APIClient";
import {BasicFPF} from "../models/BasicFPF";
import {BACKEND_URL} from "../../../env-config";


export const receiveVisibleFpfs = () => {
    const apiClient = new APIClient();

    const user = getUser();
    const token = user?.access_token;

    const headers =
        {'Authorization': `Bearer ${token}`};

    const url = `${BACKEND_URL}/api/fpfs/visible`;

    const result: Promise<BasicFPF[]> = apiClient.get(url, headers);
    return result;
}


